/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SamparkEolApiService {
  private history: string[] = [];
  private APIService = environment.serviceUrl;

  constructor(
    private http: HttpClient,
    public snackBar: MatSnackBar,
    private router: Router
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });
  }

  saveSamparkEolDevice(Payload: any): Observable<any> {
    return this.http.post(
      this.APIService + 'samparkEol/saveSamparkEol',
      Payload
    );
  }

  getSamparkEolDeviceList(
    currentPage: number,
    pageSize: number,
    search: string
  ): Observable<any> {
    return this.http.get(
      this.APIService +
        'samparkEol/getAllSamparkEol?page=' +
        currentPage +
        '&size=' +
        pageSize +
        '&search=' +
        search
    );
  }

  uploadToTml(imei: string): Observable<any> {
    return this.http.post(
      this.APIService + 'samparkEol/uploadToTml/' + imei,
      {}
    );
  }

  getSamparkEolDeviceById(imei: string): Observable<any> {
    return this.http.get(
      this.APIService + 'samparkEol/getSamparkEolByImei?imei=' + imei
    );
  }

  updateSamparkEolDeviceData(payload: any): Observable<any> {
    return this.http.put(
      this.APIService + 'samparkEol/updateSamparkEol',
      payload
    );
  }

  deleteSamparkEolData(imei: string, userId: string): Observable<any> {
    return this.http.delete(
      `${this.APIService}samparkEol/deleteSamparkEol?imei=${imei}&userId=${userId}`
    );
  }
}
